import styled from 'styled-components';

import { SmallSubtitle } from '@genially/design-system';
import { CopyIcon } from '@genially/icons';

export const Wrapper = styled.div(({ theme: { size, transition } }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: size.units(1),
  cursor: 'pointer',
  transition: transition.standard(),

  ':hover': {
    transform: 'scale(0.95)',
  },
}));

export const StyledCopyIcon = styled(CopyIcon)(({ theme: { color, size } }) => ({
  color: color.content.reversed.default(),
  width: size.units(2),
  height: size.units(2),
}));

export const Text = styled(SmallSubtitle)(({ theme: { color } }) => ({
  color: color.content.reversed.default(),
}));
